const KIBANA_LOG = require("../../../assets/images/Labs/kibana-icon.png");
const APP_UPDT = require("../../../assets/images/Labs/compare_arrows_24px.png");
const FULL_TIMELINE = require("../../../assets/images/Labs/timeline_24px.png");
const ALLOW_MULTILANGUAGE = require("../../../assets/images/Labs/language_24px.png");
const CERT_SIGN = require("../../../assets/images/Labs/CertSign-icon.png");
const ALLOW_TWO_FACTOR = require("../../../assets/images/Labs/2FA.png");
const SIGNUP = require("../../../assets/images/Labs/supervisor_account.svg");
const ACCESSIBILITY = require("../../../assets/images/brightness_medium.svg");
const TASK_DELEGATION = require("../../../assets/images/Labs/people_outline_24px.png");
const FILE_SCANNING = require("../../../assets/images/security_24px.png");
const ENABLE_AI = require("../../../assets/images/Labs/enable-ai.png");
const ENABLE_ASSISTANT = require("../../../assets/images/Labs/enable-ai.png");

export const ICONS = {
    KIBANA_LOG,
    APP_UPDT,
    FULL_TIMELINE,
    ALLOW_MULTILANGUAGE,
    CERT_SIGN,
    ALLOW_TWO_FACTOR,
    SIGNUP,
    ACCESSIBILITY,
    TASK_DELEGATION,
    FILE_SCANNING,
    ENABLE_AI,
    ENABLE_ASSISTANT
};

// page list to be configurable on feature details.
export const CONFIGURABLE_FEATURE_PAGES = {
    CERT_SIGN: "FeatureCertSign"
};

// FEATURE TEST DATA INTEGRATIONS
export const INTEGRATIONS_DATA = [
    {
        id: "Test",
        name: "CertSign",
        code: "CERT_SIGN",
        description: "Enable digital signature through CertSign for your applications.",
        enabled: false,
        hidden: false,
        type: "INTEGRATION",
        configurable: true
    }
];
